import React, { useEffect } from "react";
import { Modal, Form, DatePicker, TimePicker, Input, Upload, Button, Tag } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const DispatchDetailsModal = ({ open, onCancel, onSubmit, jobcardIds = [], loading = false }) => {
	const [form] = Form.useForm();

	useEffect(() => {
		if (!open) {
			form.resetFields();
		}
	}, [open, form]);

	const normalizeFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList || [];
	};

	const handleOk = async () => {
		try {
			const values = await form.validateFields();
			const formData = new FormData();
			formData.append("jobcards", JSON.stringify(jobcardIds));
			formData.append("delivery_date", values.delivery_date?.format("YYYY-MM-DD") || "");
			formData.append("delivery_time", values.delivery_time?.format("HH:mm:ss") || "");
			formData.append("delivery_note", values.delivery_note || "");
			if (values.delivery_acknowledgement?.length) {
				const fileObj = values.delivery_acknowledgement[0]?.originFileObj;
				if (fileObj) {
					formData.append("delivery_acknowledgement", fileObj);
				}
			}
			await onSubmit?.(formData, values);
			form.resetFields();
		} catch (error) {
			// validation errors handled by antd form
		}
	};

	const handleCancel = () => {
		form.resetFields();
		onCancel?.();
	};

	return (
		<Modal
			title="Dispatch Details"
			open={open}
			onCancel={handleCancel}
			onOk={handleOk}
			okText="Save"
			destroyOnClose
			confirmLoading={loading}
		>
			<div style={{ marginBottom: "1rem" }}>
				<strong>Selected Jobcards:</strong>
				<div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 8 }}>
					{jobcardIds.map((id) => (
						<Tag key={id}>{id}</Tag>
					))}
				</div>
			</div>
			<Form layout="vertical" form={form}>
				<Form.Item
					name="delivery_date"
					label="Delivery Date"
					rules={[{ required: true, message: "Please select delivery date" }]}
				>
					<DatePicker style={{ width: "100%" }} />
				</Form.Item>
				<Form.Item
					name="delivery_time"
					label="Delivery Time"
					rules={[{ required: true, message: "Please select delivery time" }]}
				>
					<TimePicker style={{ width: "100%" }} format="HH:mm" />
				</Form.Item>
				<Form.Item
					name="delivery_note"
					label="Delivery Note"
					rules={[{ required: true, message: "Please enter delivery note" }]}
				>
					<Input.TextArea rows={4} placeholder="Enter any delivery notes" />
				</Form.Item>
				<Form.Item
					name="delivery_acknowledgement"
					label="Delivery Acknowledgement"
					valuePropName="fileList"
					getValueFromEvent={normalizeFile}
					rules={[{ required: true, message: "Please upload acknowledgement file" }]}
				>
					<Upload beforeUpload={() => false} maxCount={1}>
						<Button icon={<UploadOutlined />}>Select File</Button>
					</Upload>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default DispatchDetailsModal;

